<template>
  <div class="scheme-container flex-box">
    <img v-lazy="bj4" alt="" class="scheme-bj">
    <div class="title">深耕细分行业，提供更加垂直的行业解决方案</div>
    <div class="description">适用于化工材料、电子高科技、机械制造、医疗器械、汽车、能源、工业设备等行业的产品生命周期管理</div>
    <div class="scheme-list flex-box">
      <mobile-tab-fold :tabs="foldTabs" :value="activeVal" @input="onFoldTab" />
      <div class="left-list">
        <div 
          class="list-item"
          :class="{'is-active': activeVal === item.val}"
          v-for="(item, k) in schemeList" 
          :key="k"
          @click="schemeClick(item)"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
      <div class="right-content">
        <div class="content-title">{{ schemeInfo.title }}</div>
        <div v-if="schemeInfo.descriptions" class="content-context-w">
          <div class="content-context" v-for="(item, k) in schemeInfo.descriptions" :key="k">{{ item }}</div>
        </div>
        <div class="content-bottom">
          <div class="content-main-desc">{{ schemeInfo.mainDesc }}</div>
          <div class="main-content">
            <ul v-if="schemeInfo.mianFeatures">
              <li v-for="(item, k) in schemeInfo.mianFeatures" :key="k">
                <div class="img-wrap" style="">
                  <img v-lazy="item.icon" width="100%" height="100%" />
                </div>
                <span>{{ item.label }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bj4 from '@/assets/images/bj4.png'
import MobileTabFold from '@/components/MobileTabFold/index.vue'
export default {
  components: { MobileTabFold },
  props: {
    schemeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      bj4,
      activeVal: '01',
      schemeInfo: {},
    }
  },
  created() {
    this.schemeInfo = this.schemeList[0]
  },
  computed: {
    foldTabs() {
      return this.schemeList.map(item => ({
        name: item.val,
        label: item.label
      }))
    }
  },
  methods: {
    schemeClick(item) {
      this.schemeInfo = item
      this.activeVal = item.val
    },
    onFoldTab(name) {
      const item = this.schemeList.find(entry => entry.val === name)
      if (item) this.schemeClick(item)
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.scheme-container {
  padding: 12.3rem 26rem;
  flex-direction: column;
  align-items: center;
  position: relative;

  .scheme-bj {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 7.2rem;
  }

  .scheme-list {
    width: 100%;
    // height: 49.6rem;
    margin-bottom: 4rem;
    background: rgba(255,255,255,0.6);
    border: .1rem solid #fff;
    .left-list {
      width: 36rem;
      // height: 49.6rem;
      background: rgba(255,255,255,0.6);
      padding: 4rem;
      box-shadow: 1rem 0rem 2rem rgba(0, 0, 0, .1);
      .list-item {
        width: 28rem;
        height: 7.2rem;
        cursor: pointer;
        margin-bottom: 1.2rem;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          height: 3.3rem;
          font-size: 2.4rem;
          font-weight: 400;
          line-height: 3.3rem;
          color: #333333;
          margin: 2rem 0 0 3.8rem;
          display: inline-block;
        }
        &.is-active {
          background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
          box-shadow: 0rem 1rem 3.7rem 0rem rgba(15,129,244,0.2);
          span {
            color: #FFFFFF;
            font-weight: 600;
          }
        }
      }
    }
    .right-content {
      flex: 1;
      padding: 4.8rem 4.8rem 5.4rem;
      .content-title {
        height: 2.4rem;
        font-size: 2.4rem;
        font-weight: 600;
        color: #333333;
        line-height: 2.4rem;
        margin-bottom: 3.4rem;
      }
      .content-main-desc,
      .content-context {
        font-size: 1.6rem;
        font-weight: 400;
        color: #333333;
        line-height: 2.2rem;
        margin-bottom: 2.4rem;
      }
      .content-bottom {
        border-top: .1rem solid #FFFFFF;
        padding-top: 2.3rem;
        .main-content {
          margin-top: 1rem;
          ul {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 1.6rem 2.4rem;
            overflow: hidden;
            padding: 0;
            margin: 0;
            li {
              list-style: none;
              margin: 0;
              text-align: center;
              min-width: 0;
              .img-wrap {
                width: 4.8rem; 
                height: 4.8rem;
                margin: 0 auto;
              }
              span {
                display: block;
                height: auto;
                font-size: 1.4rem;
                font-weight: 400;
                color: #333333;
                line-height: 2rem;
                white-space: normal;
                word-break: break-word;
              }
            }
          }
        }
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .scheme-container {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 2.4rem;
      text-align: center;
    }
    .scheme-list {
      flex-wrap: wrap;
      .left-list {
        display: none;
      }
      ::v-deep .mobile-tab-fold {
        padding: 0;
        margin: 0 0 1.6rem;
        flex: 1 1 100%;
        width: 100%;
        max-width: 100%;
      }
      .right-content {
        width: 100%;
        padding: 2.4rem 1.6rem;
        .content-title {
          height: auto;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          line-height: 3rem;
        }
        .content-context,
        .content-main-desc {
          height: auto;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
        .content-bottom .main-content ul {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 1.6rem;
          overflow: visible;
          li span {
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
          }
        }
      }
    }
  }
}
</style>
